import { render, staticRenderFns } from "./ColumnTranslatedName.vue?vue&type=template&id=2a937a89"
import script from "./ColumnTranslatedName.vue?vue&type=script&lang=js"
export * from "./ColumnTranslatedName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports